import { render, staticRenderFns } from "./PayRemain.vue?vue&type=template&id=c2c681f0&scoped=true&"
import script from "./PayRemain.vue?vue&type=script&lang=js&"
export * from "./PayRemain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c681f0",
  null
  
)

export default component.exports